import React from 'react';
import { content } from '../data/content';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ThoughtLeadership = () => {
  return (
    <section id="advisory" className="py-20 md:py-32 bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="mb-12">
          <SafeIcon icon={FiIcons.FiFeather} className="text-4xl text-slate-400 mx-auto mb-6" />
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-slate-900 mb-8">
            {content.advisory.title}
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed italic">
            "{content.advisory.text}"
          </p>
        </div>
        
        <div className="flex justify-center">
          <div className="h-24 w-px bg-slate-300"></div>
        </div>
      </div>
    </section>
  );
};

export default ThoughtLeadership;